'use strict';

import React, { useState } from 'react';
import { connect } from 'react-redux';
import Modal from 'react-modal';
import cn from 'classnames/bind';
import AsyncSelect from 'react-select/async';
import Creatable from 'react-select/creatable';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { appSelectors, appOperations } from '@/state/domains/app';
import { locationsOperations } from '@/state/domains/locations';
import { placesSelectors, placesOperations } from '@/state/domains/places';

import s from './styles.scss';
import m from '../styles.scss';

const sx = cn.bind(s);

export default connect(
	(state, props) => ({
		modals: appSelectors.getModalStates(state, props),
		modalProps: appSelectors.getModalProps(state, props),
		date: appSelectors.getPageDate(state, props),
		username: appSelectors.getPageUsername(state, props),
	}),
	{
		setModalClose: appOperations.setModalClose,
		findAddress: locationsOperations.findAddress,
		createPlace: placesOperations.createPlace,
	}
)(
	({
		modals,
		modalProps,
		setModalClose,
		findAddress,
		createPlace,
	}) => {

		const customStyles = {
			container: () => ({
				display: 'flex',
				flexDirection: 'column',
				flex: 1,
			}),
			menu: () => ({
				marginTop: '8px',
				marginBottom: '8px',
				textAlign: 'center',
			}),
		};

		const [ placeId, setPlaceId ] = useState(null);
		const [ name, setName ] = useState({ label: '', value: '' });

		const onNameChange = (txt, state) => {

			const { action } = state;

			if (action === 'input-change') {
				setName({ label: txt, value: txt });
			}
		};

		const onCancel = () => {
			setModalClose('createPlace');
		};

		let timeoutId;

		const loadOptions = inputValue => new Promise((resolve, reject) => {
			
			if (timeoutId) {
				clearTimeout(timeoutId);
			}

			timeoutId = setTimeout(
				() => {
					findAddress(inputValue).then(result => {

						const { data: { addresses }} = result;

						const opts = addresses.map(
							a => ({ label: a.address, value: a.placeId })
						);

						resolve(opts);
					});
				},
				1000
			);
		});

		const onAddressChange = ({ label, value }) => {
			setPlaceId(value);
		};

		const onSubmit = () => {

			createPlace(name.value, placeId).then(r => {
				if (r.success) {
					setModalClose('createPlace');
				} else {
				}
			}).catch(e => {
			});
		};

		return (
			<Modal
				appElement={ document.getElementById('root') }
				overlayClassName={ m.modalOverlay }
				isOpen={ modals.createPlace }
				contentLabel='Create Place'
				shouldCloseOnOverlayClick={ true }
				shouldCloseOnEsc={ true }
				onRequestClose={ () => setModalClose('createPlace') }
				className={ m.modal }
			>
				<div className={ s.root }>
					<p className={ s.header }>Create Place</p>
					<div className={ s.contents }>
						<div className={ sx('row') }>
							<label className={ s.rowLabel }>Name</label>
								<Creatable
									placeholder='Name'
									value={ name }
									options={ [] }
									onInputChange={ onNameChange }
									maxMenuHeight={ 148 }
									autoFocus={ true }
									styles={{
										menu: (provided, state) => ({
											...provided,
											display: 'none',
										}),
										indicatorsContainer: (provided, state) => ({
											...provided,
											display: 'none',
										}),
										indicatorSeparator: (provided, state) => ({
											...provided,
											display: 'none',
										}),
									}}
								/>
						</div>
						<div className={ sx('row') }>
							<label className={ s.rowLabel }>Address</label>
							<div className={ s.value }>
								<AsyncSelect
									loadOptions={ loadOptions }
									onChange={ onAddressChange }
								/>
							</div>
						</div>
					</div>
					<div className={ s.footer }>
						<div className={ m.btns }>
							<button
								onClick={ onCancel }
								className={ m.cancel }
							>
								Cancel
							</button>
							<button
								onClick={ onSubmit }
								className={ m.proceed }
							>
								Create
							</button>
						</div>
					</div>
				</div>
			</Modal>
		);
	}
);
